export default {
      id: "external-link-usage",
      viewBox: "0 0 24 29",
      url: __webpack_public_path__ + "sprite.svg#external-link",
      toString: function () {
        return this.url;
      }
    }